import { useEffect } from "react";
import { useSelector } from "../../../redux/store";
import { Game, Member } from "./Game";
import { DocumentReference, updateDoc } from "firebase/firestore";

export const useAddUserToGame = ({
  game,
  gameRef,
}: {
  game?: Game;
  gameRef: DocumentReference;
}) => {
  const currentUser = useSelector((state) => state.auth.user);

  useEffect(() => {
    if (game && currentUser) {
      const currentUsersMember = game.membersMap[currentUser.uid];

      const member: Member = {
        userId: currentUser.uid,
        displayName: currentUser.displayName ?? undefined,
      };

      if (!currentUsersMember) {
        updateDoc(gameRef, {
          [`membersMap.${currentUser.uid}`]: member,
        });
      }
    }
    //eslint-disable-next-line  react-hooks/exhaustive-deps
  }, [game, currentUser]);
};
